import { render, staticRenderFns } from "./records-detail.vue?vue&type=template&id=5f381dc9&scoped=true"
import script from "./records-detail.vue?vue&type=script&lang=js"
export * from "./records-detail.vue?vue&type=script&lang=js"
import style0 from "./records-detail.vue?vue&type=style&index=0&id=5f381dc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f381dc9",
  null
  
)

export default component.exports